<template>
  <div class="purchase-pack-wrapper" @click="selectProduct">
    <div
      class="top-wrapper"
      :class="{ most_popular: reference === 'most_popular', best_value: reference === 'best_value' }"
    >
      <p class="title">{{ $t(`purchasePacks.reference.${reference}`) }}</p>
    </div>
    <div class="body-wrapper" :class="{ highlighted }">
      <p class="purchase-amount">{{ amount }}</p>
      <p v-if="extra" class="purchase-bonus">+{{ extra }} {{ $t('rateFinder.free') }}</p>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'PuchasePackCard',
  props: {
    amount: {
      type: String,
      required: true,
    },
    highlighted: {
      type: Boolean,
      required: true,
      default: false,
    },
    reference: {
      type: String,
      required: true,
      validator: (value: string) => ['top_value', 'best_value', 'most_popular', 'starter_credit'].includes(value),
    },
    extra: {
      type: String as () => string | null,
      required: false,
      default: '',
    },
  },
  emits: ['selectPack'],
  setup(_, { emit }) {
    const selectProduct = () => {
      emit('selectPack');
    };

    return {
      selectProduct,
    };
  },
});
</script>

<style lang="scss">
.purchase-pack-wrapper {
  position: relative;
  cursor: pointer;
  height: 72px;
  overflow: hidden;
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
}

.title {
  color: white !important;
  text-align: center;
  line-height: 20px;
}

.top-wrapper {
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  height: 42px;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
}

.body-wrapper {
  border-radius: 8px;
  height: 52px;
  background-color: $color-anti-flash-white;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-top: auto;
  width: 100%;
  z-index: 1;
}

.highlighted {
  background-color: $color-water;
}

.purchase-amount {
  color: $color-space-blue !important;
  font-size: 18px;
}

.purchase-bonus {
  color: $color-blue-pigment !important;
}

.title,
.purchase-amount {
  font-family: 'Poppins';
  font-weight: 600;
}

.title,
.purchase-bonus {
  font-size: 10px;
}

.best_value {
  background-color: $primary-color;
}

.most_popular {
  background-color: $color-space-blue;
}
</style>
